import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { portalTheme } from '@prooffleet/ui';
import '@fontsource-variable/inter-tight';
import '@fontsource-variable/jetbrains-mono';
import '@mantine/core/styles.css';
import './styles.css';
import { App } from './App.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Портал — операционный экран: устаревшая лента опаснее лишнего запроса.
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('Не найден корневой элемент');

createRoot(container).render(
  <StrictMode>
    <MantineProvider theme={portalTheme} defaultColorScheme="light">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
